import { Button, List, ListItem, Popover, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, useContext, useState } from 'react';
import { FaultsDashboardsContext } from '../../contexts';

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.colors.avani.turc};
    border-radius: 8px;
    border: none;
    color: white;
    padding: 8px 12px;

    &:hover {
      border: none;
      color: ${theme.colors.avani.darkTitleText};

      .MuiSvgIcon-root {
        color: ${theme.colors.avani.darkTitleText};
      }
    }
`
);

const StyledListItem = styled(ListItem)(
  () => `
  cursor: pointer;
  display: flex;

  svg {
    margin-right: 12px;
  }
`
);

export const FaultCriticalityDropdown: FC = () => {
  const { criticalities, setCriticality } = useContext(FaultsDashboardsContext);
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [buttonLabel, setButtonLabel] = useState<string>('Criticality');

  return (
    <>
      <StyledButton
        variant="outlined"
        disabled={!criticalities.length}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: 'white',
          border: `2px solid ${theme.colors.avani.magenta}`,
          color: theme.colors.avani.teal,
          paddingTop: '8px',
          borderRadius: '32px',
          marginLeft: '18px',
          [`&:hover`]: { border: `2px solid ${theme.colors.avani.magenta}`, color: theme.colors.avani.magenta }
        }}
      >
        {buttonLabel}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <List>
          {!!criticalities.length && (
            <>
              {criticalities.length > 1 && (
                <StyledListItem
                  key={'all'}
                  value={'All'}
                  onClick={() => {
                    setCriticality(undefined);
                    setButtonLabel('Criticality');
                    setAnchorEl(null);
                  }}
                >
                  <Typography sx={{ flexGrow: 1, pt: '3px' }}>All</Typography>
                </StyledListItem>
              )}
              {criticalities.map((option, index) => {
                return (
                  <StyledListItem
                    key={index}
                    value={option ? 'Yes' : 'No'}
                    onClick={() => {
                      setCriticality(option);
                      setButtonLabel(option ? 'Yes' : 'No');
                      setAnchorEl(null);
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, pt: '3px' }}>{option ? 'Yes' : 'No'}</Typography>
                  </StyledListItem>
                );
              })}
            </>
          )}
        </List>
      </Popover>
    </>
  );
};
